/**
 *  Copyright (c) 2022-present TVM Engineering Authors.
 *
 */

import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { translate } from "react-i18next";
import { Typography, TextField, Button, FormControl, InputAdornment } from "@mui/material";
import { PersonOutlined } from "@mui/icons-material";
import { checkEmailOnPasswordReset } from "../../services/auth";
import SINGUP_BACKGROUND from "../../assets/img/landing_main_background.png";
import i18n from "../../services/i18n";
import { toast_notifications } from "../../utils/notifications";

const initialState = {
  email: "",
};

const ForgotPassword = React.memo(() => {
  const dispatch = useDispatch();

  const [state, setState] = useState(initialState);
  const [emailSendSuccessfully, setEmailSendSuccessfully] = useState(false);

  useEffect(() => {}, [dispatch]);

  function handleInputChange(event) {
    const target = event.target;
    const value = target.type === "checkbox" ? target.checked : target.value;
    const name = target.name;

    setState({
      ...state,
      [name]: value,
    });
  }

  async function checkEmailOnPasswordResetHandler() {
    const isEmailExists = await dispatch(checkEmailOnPasswordReset({ email: state.email }));
    setEmailSendSuccessfully(isEmailExists);
    if (state.email === "") {
      toast_notifications.warning("Field is empty!");
    } else if (!isEmailExists) {
      toast_notifications.error("This email do not exist!");
    }
  }

  return (
    <div style={styles.root}>
      <Typography component="div" sx={styles.createToolPopup}>
        {emailSendSuccessfully && (
          <Typography component="h1">{i18n.t("core:EmailSuccessfullySend")}</Typography>
        )}

        {!emailSendSuccessfully && (
          <Typography component="div">
            <FormControl fullWidth={true}>
              <TextField
                required
                // sx={styles.textField}
                autoFocus={true}
                label={i18n.t("core:emailAddress")}
                onChange={handleInputChange}
                placeholder="example@mail.com"
                inputMode="email"
                name="email"
                value={state.email}
                type="email"
                margin="dense"
                variant="outlined"
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <PersonOutlined sx={styles.personIcon} />
                    </InputAdornment>
                  ),
                }}
                size="small"
              />
            </FormControl>

            <Typography component="div" sx={styles.alignSignUpButton}>
              <Button
                variant="contained"
                color="primary"
                sx={styles.singUpButton}
                onClick={checkEmailOnPasswordResetHandler}
              >
                Reset password
              </Button>
            </Typography>
          </Typography>
        )}
      </Typography>
    </div>
  );
});

export default translate(["core"], { wait: true })(ForgotPassword);

const styles = {
  root: {
    minHeight: "750px",
    background: "#DDE5EF",
    overflowX: "hidden",
    overflowY: "hidden",
    padding: 20,
    backgroundImage: `url(${SINGUP_BACKGROUND})`,
    backgroundSize: "cover",
    backgroundRepeat: "no-repeat",
    backgroundPosition: "center",
    fontWeight: "300",
  },
  createToolPopup: {
    background: "#fff",
    width: "30%",
    margin: "0px auto",
    marginTop: "130px",
    webkitBoxShadow: "0px 0px 5px 0px rgba(0,0,0,0.75)",
    mozBoxShadow: "0px 0px 5px 0px rgba(0,0,0,0.75)",
    boxShadow: "0px 0px 5px 0px rgba(0,0,0,0.75)",
    padding: "40px 35px 35px 35px",
    minWidth: "450px",
  },
  textField: {
    "& input": {
      paddingLeft: "30px",
    },

    [`& fieldset`]: {
      borderRadius: 0,
    },
  },
  alignSignUpButton: {
    display: "flex",
    justifyContent: "left",
  },
  singUpButton: {
    marginTop: "25px",
  },
};
